import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React from 'react'
import {
  EXCLUDE_FROM_GROSS_PROFIT_HEADER_LINES,
  EXCLUDE_FROM_GROSS_PROFIT_TOOLTIP,
} from './excludeFromGrossProfit'
import {
  DEFAULT_QUANTITY_COLUMN_TOOLTIP,
  DEFAULT_QUANTITY_TOOLTIP_DEFINITION,
  PAR_LEVEL_OUTCOME_LINE,
  PAR_LEVEL_TOOLTIP_DEFINITION,
  SECONDARY_ZONE_COLUMN_TOOLTIP_DEFINITION,
  ZONE_COLUMN_TOOLTIP_DEFINITION,
} from './parLevelMarketingCopy'

export const ParLevelFieldTooltipContent = () => (
  <span>
    {PAR_LEVEL_TOOLTIP_DEFINITION}
    <br />
    <br />
    {DEFAULT_QUANTITY_TOOLTIP_DEFINITION}
    <br />
    <br />
    {PAR_LEVEL_OUTCOME_LINE}
  </span>
)

export const ZoneColumnTooltipContent = () => (
  <span>
    {ZONE_COLUMN_TOOLTIP_DEFINITION}
    <br />
    <br />
    {SECONDARY_ZONE_COLUMN_TOOLTIP_DEFINITION}
  </span>
)

export const DefaultQtyColumnTooltipContent = () => (
  <span>{DEFAULT_QUANTITY_COLUMN_TOOLTIP}</span>
)

export const ExcludeFromGrossProfitTooltipContent = () => (
  <span>{EXCLUDE_FROM_GROSS_PROFIT_TOOLTIP}</span>
)

export const ColumnHeaderWithTooltip = ({
  label,
  tooltip,
  nowrap = false,
  stack = false,
}) => (
  <Tooltip title={tooltip}>
    <span
      style={{
        display: stack ? 'inline-block' : 'inline-flex',
        alignItems: 'center',
        gap: stack ? undefined : '4px',
        textAlign: stack ? 'center' : undefined,
        lineHeight: stack ? 1.15 : undefined,
        whiteSpace: nowrap ? 'nowrap' : 'normal',
        wordBreak: nowrap ? 'normal' : 'keep-all',
      }}
    >
      {label}
      {stack ? ' ' : null}
      <InfoCircleOutlined style={{ fontSize: '12px', color: '#8c8c8c' }} />
    </span>
  </Tooltip>
)

export const ExcludeFromGrossProfitColumnHeader = () => (
  <ColumnHeaderWithTooltip
    label={EXCLUDE_FROM_GROSS_PROFIT_HEADER_LINES.map((line, index) => (
      <React.Fragment key={line}>
        {index > 0 ? <br /> : null}
        {line}
      </React.Fragment>
    ))}
    tooltip={<ExcludeFromGrossProfitTooltipContent />}
    stack
  />
)
